export default __webpack_public_path__ + "static/media/circleinfo.458d5980.svg";